<template>
  <div class="markup-tables">
    <va-card :title="$t('tables.basic')" class="mb-2">
      <table class="va-table">
        <thead>
          <tr>
            <th class="md3">Consent Title</th>
            <th class="md3">Consent Question</th>
            <th style="width:20%">Form</th>
            <th class="addBox"></th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="consent in consents" :key="consent.id">
            <td>
              <va-input
                required
                class="md3"
                v-model="consent.consentTitle"
                size="5px"
              ></va-input>
            </td>
            <td class="md3 gridInput">
              <va-input v-model="consent.consentQuestion" size="5px"></va-input>
            </td>
            <td class="md4 gridInput">
              <va-select
                v-model="consent.selectedForm"
                keyBy="formId"
                :options="forms"
                textBy="formTitle"
                searchable
              ></va-select>
            </td>
            <td>
              <va-button
                v-if="consent.show"
                @click="addRow(consent)"
                icon="fa fa-plus"
                >ADD</va-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pull-right">
 
        </va-input-wrapper>
        <va-button @click="cancel" color="warning">Cancel</va-button>
        <va-button @click="create" color="success">Submit</va-button>
      </div>
      <va-notification v-model="isVisible" :color="color" closeable>
        <va-badge color="success"> Paid </va-badge>
        You successfully read this important alert message.
      </va-notification>
      <!-- <req-spinner :loading="loading" :color="color" /> -->
    </va-card>
  </div>
</template>

<script>
import service from "../consentsService.js";
import ReqSpinner from "../../../app/RequestSpinner.vue";

export default {
  data() {
    return {
      consents: [
        {
          id: 1,
          consentTitle: "",
          consentQuestion: "",
          show: true,
          selectedForm: ""
        }
      ],
      forms: [],
      loading: false,
      color: "#719BAE",
      notificationColor: undefined,
      isVisible: false
    };
  },
  methods: {
    debug() {
      this.$toasted.error("Consent Created Succesfully", {
        icon: "fa-check",
        position: "top-right",
        duration: 2000,
        fullWidth: false
      });
    },
    create() {
      this.loading = true;
      let newConsent;
    
        if (this.consents.length > 1) {
          newConsent = [];
          this.consents.forEach(consent => {
            newConsent.push({
              formId: consent.selectedForm.formId,
              consentTitle: consent.consentTitle,
              consentQuestion: consent.consentQuestion
            });
          });
          service.createConsents(newConsent).then(res => {
            this.loading = false;
            this.$router.push("/");
          }).then(res =>{
             this.$toasted.success("Consent Created Succesfully", {
                icon: "fa-check",
                position: "top-right",
                duration: 2000,
                fullWidth: false
            })

            this.$router.go({name:"consents"})
          }).catch(error => {
              const message =
                error.response.data.message == undefined
                  ? "Something went wrong"
                  : error.response.data.message;

              this.$toasted.error(message, {
                icon: "fa-close",
                position: "top-right",
                duration: 2000,
                fullWidth: false
              });
          })
        } else {
          let tempConsent = this.consents[0];
          newConsent = {
            formId: tempConsent.selectedForm.formId,
            consentTitle: tempConsent.consentTitle,
            consentQuestion: tempConsent.consentQuestion
          };
          service
            .createConsent(newConsent)
            .then(res => {
              this.$toasted.success("Consent Created Succesfully", {
                icon: "fa-check",
                position: "top-right",
                duration: 2000,
                fullWidth: false
              });

              this.$router.push("/");

              // this.color = "#40e583";
              // setTimeout(y => {
              //   this.loading = false;
              //   this.$router.push("/");
              // }, 500)
            })
            .catch(error => {
              const message =
                error.response.data.message == undefined
                  ? "Something went wrong"
                  : error.response.data.message;

              this.$toasted.error(message, {
                icon: "fa-close",
                position: "top-right",
                duration: 2000,
                fullWidth: false
              });

              // this.color = "#F40908";
              // setTimeout(y => {
              //   this.loading = false;
              //   console.log(error.response.data.message);
              // }, 500);
            });
        }
      
    },
    cancel() {
      this.$router.push({ name: "consents" });
    },
    addRow(props) {
      let consentsLength;
      consentsLength = this.consents.length;

      let id;
      if (consentsLength >= 1) {
        delete this.consents[consentsLength - 1].show;
        id = this.consents[consentsLength - 1].id + 1;
      }

      this.consents.push({
        id: id,
        name: "",
        surname: "",
        selectedForm: "",
        show: true
      });
    }
  },
  components: {
    ReqSpinner
  },
  created() {
    service.fetchForms().then(res => {
      let data = res.data.displayFormDTOList;
      data.forEach(element => {
        this.forms.push({
          formId: element._id,
          formTitle: element.formTitle
        });
      });
    });
  }
};
</script>

<style scoped>
va-table {
  width: 100%;
}

.addBox {
  width: 10%;
}

.va-card {
  max-width: 1200px;
}

.gridInput {
  margin-right: 5px;
}
</style>
